import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Typography, Alert, Stack, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { usePutDataFetch } from '../../utils/useDataFetch';

const EditMemberDialog = ({ open, member, teamId, onClose, onSaved }) => {
  const { response, error, isLoading, putData } = usePutDataFetch();
  const [role, setRole] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const val = member?.sekundaer_rolle;
    if (Array.isArray(val)) setRole(val);
    else if (typeof val === 'string' && val.trim() !== '') setRole(val.split(',').map(s => s.trim()));
    else setRole([]);
  }, [member]);

  useEffect(() => {
    if (!saving) return;

    if (!isLoading) {
      if (response?.data?.success) {
        onSaved?.();
        onClose();
      }
      setSaving(false);
    }
  }, [saving, isLoading, response, error, onClose, onSaved]);

  const handleSave = async () => {
    if (!member) return;
    setSaving(true);

    const payloadRole = Array.isArray(role) ? role.join(',') : (role || null);
    await putData({
      url: `/teams/${teamId}/member/${member.id}/secondary-role`,
      aBody: { sekundaer_rolle: payloadRole || null }
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Mitglied bearbeiten</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <div>
            <Typography variant="subtitle2">Name</Typography>
            <Typography variant="body1" fontWeight="bold">
              {member?.first_name} {member?.last_name}
            </Typography>
          </div>

          <div>
            <Typography variant="subtitle2">Team-Rolle</Typography>
            <Typography variant="body1">
              {member?.team_role === 'trainer' ? 'Trainer' : 'Spieler'}
            </Typography>
          </div>

          <FormControl fullWidth>
            <InputLabel>Sekundäre Rolle</InputLabel>
            <Select
              multiple
              value={role}
              label="Sekundäre Rolle"
              onChange={(event) => setRole(event.target.value)}
              renderValue={(selected) => selected.join(', ')}
            >
              <MenuItem value="kassenwart">Kassenwart</MenuItem>
              <MenuItem value="statistikwart">Statistikwart</MenuItem>
              <MenuItem value="instateam">Instateam</MenuItem>
            </Select>
          </FormControl>

          {error && <Alert severity="error">{error}</Alert>}
          {response?.data?.success && <Alert severity="success">Rolle erfolgreich gespeichert.</Alert>}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Abbrechen
        </Button>
        <Button onClick={handleSave} variant="contained" disabled={isLoading || !member}>
          {isLoading ? 'Speichern...' : 'Speichern'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditMemberDialog;
